/** Web app: local/dev API (e.g. Vite proxy or local.warrcloud.org). */
export const devEnv = {
    apiUrl: 'http://local.warrcloud.org',
};

export const prodEnv = {
    apiUrl: 'http://local.warrcloud.org',
};

export const stagingEnv = {
    apiUrl: 'http://local.warrcloud.org',
};

/** Extension: use same API as web (api-dev) so ALB Bearer rule applies. */
export const extensionEnv = {
    apiUrl: 'https://api-dev.warrcloud.org',
};
